

import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

// import RefreshIcon from "../../../../core/common/tooltip-content/refresh";
import { Select, Spin } from "antd";
// import { Trash } from "feather-icons-react/build/IconComponents";
import { Payroll_API_BASE_URL } from "../PConfig/PConfig";
import Table1 from "../../../../core/pagination/datatable";
import CommonFooter from "../../../../core/common/footer/commonFooter";
import {
  Filter,
   Search,
} from "feather-icons-react/build/IconComponents";
const SalaryList = () => {
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [employeesList, setEmployeesList] = useState([]);
  const [selectedEmpRegId, setSelectedEmpRegId] = useState([0]);
  const [branchesList, setBranchesList] = useState([]);
  const [SelectedBranchId, setSelectedBranchId] = useState([0]);
  const [PayPeriodlist, setPayPeriodlist] = useState([]);
  const [SalaryAvnceData, setSalaryAvnceData] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [DeptList, setDeptList] = useState([]);
  const [SelectedDeptId, setSelectedDeptId] = useState([0]);
  const [selectedPayPeriod, setSelectedPayPeriod] = useState([0]);
  const [showAdvancedSearch, setShowAdvancedSearch] = useState(false);

  const formatINR = (val) =>
    `₹${Number(val || 0).toLocaleString("en-IN")}`;

  const Columns = [
    {
      title: "Badge",
      dataIndex: "Badge",
      key: "Badge",
    },
    {
      title: "Employee",
      dataIndex: "EmployeeName",
      key: "EmployeeName",
      render: (text) => (
        <span title={text}>
          {text?.length > 15 ? `${text.slice(0, 15)}...` : text}
        </span>
      ),
    },
    {
      title: "Monthly (₹)",
      dataIndex: "TotalAmount",
      render: formatINR,
      key: "TotalAmount",

    },
    {
      title: "Basic",
      dataIndex: "BasicAmount",
      render: formatINR,
      key: "BasicAmount",
    },
    {
      title: "HRA",
      dataIndex: "HRA",
      render: formatINR,
      key: "HRA",

    },
    {
      title: "Conveyance",
      dataIndex: "Conveyance",
      render: formatINR,
      key: "Conveyance",

    },
    {
      title: "Medical",
      dataIndex: "MedicakAllowance",
      render: formatINR,
      key: "MedicakAllowance",

    },
    {
      title: "Special",
      dataIndex: "SpecialAllowance",
      render: formatINR,
      key: "SpecialAllowance",
    },
    {
      title: "OT",
      dataIndex: "OT",
      render: formatINR,
      key: "OT",

    },


    // {
    //   title: "Actions",
    //   key: "actions",
    //   width: 80,
    //   render: (_, record) => (
    //     <Link className="me-2 p-2" onClick={() => handleDelete(record)}>
    //           <Trash className="feather-trash" />
    //         </Link>
    //   ),
    // },
  ];

  const navigate = useNavigate();

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    // const superId = sessionStorage.getItem("superId");
    const superId = sessionStorage.getItem("PayrollSuperId");


    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  // useEffect(() => {
  //   if (tokenData && superIdData) {
  //     const fetchEmployeesList = async () => {
  //       try {
  //         const response = await fetch(
  //           `${Payroll_API_BASE_URL}portal/emp/getemployees?superid=${superIdData}`,
  //           {
  //             headers: {
  //               "Content-Type": "application/json",
  //               // Authorization: `Bearer ${tokenData}`,
  //               Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,

  //             },
  //           }
  //         );

  //         if (!response.ok) {
  //           throw new Error("Failed to fetch Employees");
  //         }

  //         const data = await response.json();

  //         if (data.status) {
  //           setEmployeesList(data.ResultData);
  //         } else {
  //           console.error("Invalid Employees response structure:", data);
  //         }
  //       } catch (error) {
  //         console.error("Error fetching EmployeesList:", error.message);
  //       }
  //     };
  //     fetchEmployeesList();
  //   }
  // }, [superIdData, tokenData]);
  useEffect(() => {
    if (!superIdData) return;

    const fetchTableEmployees = async () => {
      try {
        const branchId = showAdvancedSearch ? SelectedBranchId : 0;
        const deptId = showAdvancedSearch ? SelectedDeptId : 0;

        // In advanced search, wait until both selected
        if (showAdvancedSearch && (!branchId || !deptId)) {
          setEmployeesList([]);
          return;
        }

        const response = await fetch(
          `${Payroll_API_BASE_URL}payroll/payroll/getemployees?superid=${superIdData}&BranchId=${branchId}&DeptId=${deptId}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
            },
          }
        );

        const data = await response.json();
        setEmployeesList(data.status ? data.ResultData : []);
      } catch (error) {
        console.error("Employee fetch error:", error);
        setEmployeesList([]);
      }
    };

    fetchTableEmployees();
  }, [
    superIdData,
    showAdvancedSearch,
    SelectedBranchId,
    SelectedDeptId,
  ]);
  useEffect(() => {
    if (tokenData && superIdData) {
      const fetchBranchsList = async () => {
        try {
          const response = await fetch(
            `${Payroll_API_BASE_URL}portal/branch/getbranch?superid=${superIdData}`,
            {
              headers: {
                "Content-Type": "application/json",
                // Authorization: `Bearer ${tokenData}`,
                Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,

              },
            }
          );

          if (!response.ok) {
            throw new Error("Failed to fetch Branches");
          }

          const data = await response.json();

          if (data.status) {
            setBranchesList(data.ResultData);
          } else {
            console.error("Invalid Branches response structure:", data);
          }
        } catch (error) {
          console.error("Error fetching BranchesList:", error.message);
        }
      };
      fetchBranchsList();
    }
  }, [superIdData, tokenData]);

  useEffect(() => {
    if (tokenData && superIdData) {
      const fetchDeptList = async () => {
        try {
          const response = await fetch(
            `${Payroll_API_BASE_URL}portal/department/getdepartment?superid=${superIdData}`,
            {
              headers: {
                "Content-Type": "application/json",
                // Authorization: `Bearer ${tokenData}`,
                Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,

              },
            }
          );

          if (!response.ok) {
            throw new Error("Failed to fetch Dept");
          }

          const data = await response.json();

          if (data.status) {
            setDeptList(data.ResultData);
          } else {
            console.error("Invalid Dept response structure:", data);
          }
        } catch (error) {
          console.error("Error fetching DeptList:", error.message);
        }
      };
      fetchDeptList();
    }
  }, [superIdData, tokenData]);

  useEffect(() => {
    if (tokenData && superIdData) {
      const fetchPayPeriodsList = async () => {
        try {
          const response = await fetch(
            `${Payroll_API_BASE_URL}payroll/payroll/getPayPeriods?SuperId=${superIdData}`,
            {
              headers: {
                "Content-Type": "application/json",
                // Authorization: `Bearer ${tokenData}`,
                Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,

              },
            }
          );

          if (!response.ok) {
            throw new Error("Failed to fetch Employees");
          }

          const data = await response.json();

          if (data.status) {
            setPayPeriodlist(data.ResultData);
          } else {
            console.error("Invalid Employees response structure:", data);
          }
        } catch (error) {
          console.error("Error fetching EmployeesList:", error.message);
        }
      };
      fetchPayPeriodsList();
    }
  }, [superIdData, tokenData]);

  const fetchSlaryData = async (empRegId) => {
    if (!tokenData || !superIdData || !empRegId) return;

    setDataLoading(true);

    try {
      const params = new URLSearchParams({
        SuperId: superIdData,
        EmployeeId: selectedEmpRegId || 0,
        BranchId: SelectedBranchId || 0,
        DeptId: SelectedDeptId || 0,
        PayPeriodId: selectedPayPeriod?.value || 0,
      });
      const response = await fetch(
        // `${Payroll_API_BASE_URL}payroll/payroll/getSalaryList?SuperId=${superIdData}&EmployeeId=0&BranchId=0&DeptId=0&PayPeriodId=0`,
        `${Payroll_API_BASE_URL}payroll/payroll/getSalaryList?${params.toString()}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `Bearer ${tokenData}`,
            Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch SalaryAvnceData");
      }

      const data = await response.json();

      if (data.status) {
        setSalaryAvnceData(data.ResultData || []);
      } else {
        console.error("API Error:", data.ErrorMsg);
      }
    } catch (error) {
      console.error("Error fetching SalaryAvnceData CTC:", error);
    } finally {
      setDataLoading(false);
    }
  };

  useEffect(() => {
    if (selectedEmpRegId) {
      fetchSlaryData(selectedEmpRegId);
    }
  }, [selectedEmpRegId, selectedPayPeriod, tokenData, superIdData]);

  // const empOptions = [
  //   { label: "All Employees", value: 0 },
  //   ...(employeesList?.map((emp) => ({
  //     label: emp.UserName,
  //     value: emp.RegId,
  //   })) || []),
  // ];
  const BranchesOptions = [
    { label: "All Branches", value: 0 },
    ...(branchesList?.map((branch) => ({
      label: branch.Name,
      value: branch.branchid,
    })) || []),
  ];
  const DeptOptions = [
    { label: "All Dept", value: 0 },
    ...(DeptList?.map((Dept) => ({
      label: Dept.Name,
      value: Dept.DepartmentId,
    })) || []),
  ];
  const PayperiodOptions = [
    { label: "All PayPeriods", value: 0 },
    ...(PayPeriodlist?.map((period) => ({
      label: period.Name,
      value: period.Id,
    })) || []),
  ];
  return (
    <>
      <style>
        {`
  .ctc-table .ant-table-thead > tr > th {
    background-color: #d2e6f5ff !important; /* light blue */
  }
.ctc-info-2col {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 🔹 two per row */
  column-gap: 20px;
  row-gap: 8px;
}

.ctc-pair {
  display: flex;
  align-items: start;
}

.ctc-label {
  min-width: 100px; /* 🔹 keeps alignment */
  font-weight: 600;
}

.ctc-label::after {
  margin-right: 6px;
}

.ctc-value {
  font-weight: 500;
}


`}
      </style>
      <div className="page-wrapper">
        <div className="content">
          {/* Header */}
          <div className="page-header m-2">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/rollcall/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      SalaryList
                    </h4>
                  </ol>
                </nav>
                <h6>Manage employee salary details</h6>
              </div>
            </div>
            {/* <ul className="table-top-head">
              <RefreshIcon />

              <li>
                <Link
                  to="#"
                  className="btn btn-success"
                  onClick={(e) => {
                    e.preventDefault();
                    setDrawerOpen(true);
                  }}
                >
                  <i className="ti ti-circle-plus fs-4"></i>
                </Link>
              </li>
            </ul> */}
          </div>

          <div className="card table-list-card">
            <div className="">
              <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3 p-0">
                <div className="search-set "></div>
                <div className="d-flex align-items-center flex-wrap row-gap-3">
                  <h5 className="mb-2  me-2 ">
                    Pay Period: {selectedPayPeriod?.label || "All PayPeriods"}
                  </h5>
                  <div className="dropdown me-2 pt-3">
                    <div className="input-blocks">
                      <i data-feather="grid" className="info-img" />

                      <Select
                        showSearch
                        labelInValue
                        placeholder="Choose PayPeriod"
                        value={selectedPayPeriod}
                        onChange={(option) => setSelectedPayPeriod(option)}
                        options={PayperiodOptions}
                        style={{ width: 170, height: 37 }}
                        filterOption={(input, option) =>
                          option?.label?.toLowerCase().includes(input.toLowerCase())
                        }
                      />
                    </div>
                  </div>

                  {/* <div className="dropdown me-2 pt-3">
                    <div className="input-blocks">
                      <i data-feather="check-circle" className="info-img" />
                      <Select
                        showSearch
                        placeholder="Choose Branch"
                        value={SelectedBranchId}
                        onChange={(val) => setSelectedBranchId(val)}
                        options={BranchesOptions}
                        style={{ width: 170, height: 37 }}
                        filterOption={(input, option) =>
                          option?.label?.toLowerCase().includes(input.toLowerCase())
                        }
                      />
                    </div>
                  </div>
                  <div className="dropdown me-2 pt-3">
                    <div className="input-blocks">
                      <i data-feather="check-circle" className="info-img" />
                      <Select
                        showSearch
                        placeholder="Choose Dept"
                        value={SelectedDeptId}
                        onChange={(val) => setSelectedDeptId(val)}
                        options={DeptOptions}
                        style={{ width: 170, height: 37 }}
                        filterOption={(input, option) =>
                          option?.label?.toLowerCase().includes(input.toLowerCase())
                        }
                      />
                    </div>
                  </div>
                  <div className="dropdown me-2 pt-3">
                    <div className="input-blocks">
                      <i data-feather="check-circle" className="info-img" />
                      <Select
                        showSearch
                        placeholder="Choose Employee"
                        value={selectedEmpRegId}
                        onChange={(val) => setSelectedEmpRegId(val)}
                        options={empOptions}
                        style={{ width: 170, height: 37 }}
                        filterOption={(input, option) =>
                          option?.label?.toLowerCase().includes(input.toLowerCase())
                        }
                      />
                    </div>
                  </div> */}
                  {/* Branch & Dept (Advanced Search Only) */}
                  {showAdvancedSearch && (
                    <>
                      <div className="dropdown me-2 pt-3">
                        <div className="input-blocks">
                          <i data-feather="check-circle" className="info-img" />
                          <Select
                            showSearch
                            placeholder="Choose Branch"
                            value={SelectedBranchId}
                            onChange={(val) => setSelectedBranchId(val)}
                            options={BranchesOptions}
                            style={{ width: 170, height: 37 }}
                            filterOption={(input, option) =>
                              option?.label?.toLowerCase().includes(input.toLowerCase())
                            }
                          />
                        </div>
                      </div>

                      <div className="dropdown me-2 pt-3">
                        <div className="input-blocks">
                          <i data-feather="check-circle" className="info-img" />
                          <Select
                            showSearch
                            placeholder="Select Dept"
                            value={SelectedDeptId}
                            onChange={(val) => setSelectedDeptId(val)}
                            options={DeptOptions}
                            style={{ width: 170, height: 37 }}
                            filterOption={(input, option) =>
                              option?.label?.toLowerCase().includes(input.toLowerCase())
                            }
                          />
                        </div>
                      </div>
                    </>
                  )}

                  {/* Employee Dropdown (Always Visible) */}
                  <div className="dropdown me-2 pt-3">
                    <div className="input-blocks">
                      <i data-feather="check-circle" className="info-img" />
                      <Select
                        showSearch
                        placeholder="Select Employee"
                        value={selectedEmpRegId}
                        onChange={(val) => setSelectedEmpRegId(val)}
                        options={[
                          { label: "All Employees", value: 0 },
                          ...employeesList.map((emp) => ({
                            label: emp.UserWithBadge,
                            value: emp.RegId,
                          })),
                        ]}
                        style={{ width: 200, height: 37 }}
                        optionFilterProp="label"
                        virtual={false}
                      />
                    </div>
                  </div>
                  <div className="dropdown me-2 pt-3">
                    <div className="input-blocks">
                      <i data-feather="check-circle" className="info-img" />
                      <button
                      type="button"
                      className={`btn btn-outline-primary d-flex align-items-center justify-content-center ${showAdvancedSearch ? "active" : ""
                        }`}
                      onClick={() => {
                          setShowAdvancedSearch((prev) => !prev);
                          setSelectedBranchId(0);
                          setSelectedDeptId(0);
                          setSelectedEmpRegId(0);
                        }}
                     title={showAdvancedSearch ? "Close Advanced Search" : "Open Advanced Search"}
                                          style={{ width: 38, height: 38 }}
                                        >
                                          {showAdvancedSearch ? (
                                                                 <Search
                                                                   size={26}
                                                                   style={{ transform: "scale(1.7)" }}
                                                                 />
                                                               ) : (
                                                                 <Filter
                                                                   size={26}
                                                                   style={{ transform: "scale(1.7)" }}
                                                                 />
                                                               )}
                                        </button>
                    </div>
                  </div>

                </div>
              </div>

              <div className="table-responsive">
                {dataLoading ? (
                  <div className="text-center my-4">
                    <Spin size="large" />
                    <p>Loading data...</p>
                  </div>
                ) : (
                  <Table1 columns={Columns} dataSource={SalaryAvnceData} rowKey="id" pgno={true} />
                )}
              </div>
            </div>
          </div>
        </div>
        {/* Footer */}
        <CommonFooter />
      </div>
    </>
  );
};

export default SalaryList;
